import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import * as icons from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal, Kicker } from "../components/Reveal";
import { SERVICES, IMAGES } from "../data/site";

const Services = () => (
    <div data-testid="services-page">
        <PageHero
            kicker="SERVICES"
            title="From Engineering"
            accent="To Support"
            sub="Complete lifecycle capability — design, manufacturing, automation, installation, commissioning and service."
            image={IMAGES.wiring}
            crumb="Services"
        />
        <section className="bg-white py-20 md:py-24">
            <div className="mx-auto max-w-[1440px] px-4 sm:px-6 lg:px-10">
                <div className="grid gap-px bg-slate-200 sm:grid-cols-2 lg:grid-cols-4">
                    {SERVICES.map((s, i) => {
                        const Icon = icons[s.icon];
                        return (
                            <Reveal key={s.name} delay={Math.min(i * 0.06, 0.4)}>
                                <div className="group relative h-full bg-white p-8 transition-colors duration-300 hover:bg-brand-ink" data-testid={`service-${s.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
                                    <p className="font-mono text-[10px] tracking-[0.22em] text-slate-400 transition-colors group-hover:text-brand-ember">
                                        {String(i + 1).padStart(2, "0")}
                                    </p>
                                    <Icon size={26} strokeWidth={1.5} className="mt-4 text-brand-red transition-colors duration-300 group-hover:text-brand-ember" />
                                    <h2 className="mt-4 font-display text-base font-bold uppercase leading-snug text-brand-charcoal transition-colors duration-300 group-hover:text-white">
                                        {s.name}
                                    </h2>
                                    <p className="mt-3 text-sm leading-relaxed text-slate-500 transition-colors duration-300 group-hover:text-slate-400">
                                        {s.desc}
                                    </p>
                                    <span className="absolute bottom-0 left-0 h-[3px] w-0 bg-brand-red transition-all duration-500 group-hover:w-full" />
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
                <Reveal delay={0.2}>
                    <div className="mt-16 flex flex-col items-start justify-between gap-6 border border-slate-200 bg-brand-mist p-8 sm:flex-row sm:items-center md:p-10">
                        <div>
                            <Kicker>SERVICE REQUEST</Kicker>
                            <p className="mt-3 font-display text-2xl font-extrabold uppercase text-brand-charcoal">Need service, spares or an upgrade?</p>
                        </div>
                        <Link to="/contact" data-testid="services-contact-cta"
                            className="group flex shrink-0 items-center gap-3 bg-brand-red px-7 py-4 font-display text-sm font-bold tracking-[0.14em] text-white transition-colors hover:bg-brand-charcoal">
                            CONTACT SERVICE TEAM <ArrowRight size={16} className="transition-transform group-hover:translate-x-1" />
                        </Link>
                    </div>
                </Reveal>
            </div>
        </section>
    </div>
);

export default Services;
